import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { s_info_circle } from '@fiverr-private/fit/icons';
import * as Translations from '../../providers/i18n';

function ConversationWontBeSeenStatus({ i18n }) {
    return (
        <div className="info-status">
            <Icon className="info-icon">{s_info_circle}</Icon>
            {i18n.t('attachments_preview.invite.wont_be_seen')}
        </div>
    );
}

ConversationWontBeSeenStatus.propTypes = {
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(ConversationWontBeSeenStatus);
